import React from 'react';

const Feedback = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Feedback</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg d-flex justify-content-center align-items-center" >
        <form className='p-5 w-50 ' style={{background:'#c2ffe3',borderRadius:"8px"}}>
          
          <div className="mb-3">
            <label htmlFor="name" className="form-label fw-bold">Name<sup style={{color:'red'}}>*</sup></label>
            <input type="text" className="form-control" id="name" placeholder="enter your name" required />
          </div>

        
          <div className="mb-3">
            <label htmlFor="email" className="form-label fw-bold">Email<sup style={{color:'red'}}>*</sup></label>
            <input type="email" className="form-control" id="email" placeholder="enter your email" required />
          </div>

          <div className="mb-3">
            <label htmlFor="subject" className="form-label fw-bold">Subject<sup style={{color:'red'}}>*</sup></label>
            <input type="text" className="form-control" id="subject" placeholder="enter subject" required />
          </div>

       
          <div className="mb-3"> 
            <label htmlFor="message" className="form-label fw-bold">Message<sup style={{color:'red'}}>*</sup></label>
            <textarea className="form-control" id="message" rows="4" placeholder="enter your message" required></textarea>
          </div>

          <div className="mb-3 text-center"> 
          <button type="submit" className="btn btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Feedback;
